<div class="upsell-items-editor">
  <pdq-tabs-group variant="underline" (onChange)="onTabChange($event)" [leftMargin]="'none'">
    @for (tab of tabs; track tab.value) {
      <pdq-tab [label]="tab.label" [value]="tab.value" [active]="tab.value === activeTab"></pdq-tab>
    }
  </pdq-tabs-group>

  <div class="upsell-items-editor__content">
    <section [style.display]="activeTab === 'product-selection' ? null : 'none'">
      <smart-cart-form-token-section [token]="usageToken"></smart-cart-form-token-section>
      <smart-cart-upsell-product-selection
        [formGroup]="productSelectionGroup"
        [globalSettingsFormGroup]="globalSettingsFormGroup"
        [customCodeGroup]="customCodeGroup"
        [customCodeDefault]="customCodeStarter"
        [customCodeVariables]="customCodeVariables"></smart-cart-upsell-product-selection>
    </section>

    <section [style.display]="activeTab === 'timer' ? null : 'none'">
      <smart-cart-timer-config
        [formGroup]="timerGroup"
        [placementOptions]="timerPlacementOptions"
        enableSubtitle="Add urgency with a countdown on your upsell offer."
        durationHint="Timer starts when customer reaches checkout"
        [smartCartId]="smartCartId"
        [usageToken]="usageToken"
        hideBehaviorLabel="Hide upsell"
        [previewedState]="timerPreviewState()"
        (previewStateChange)="setTimerPreview($event)"></smart-cart-timer-config>

      <smart-cart-form-custom-code
        [enabledControl]="customCodeGroup.controls.enabled"
        [codeControl]="customCodeGroup.controls.code"
        [defaultCode]="customCodeStarter"
        [variables]="customCodeVariables"></smart-cart-form-custom-code>
    </section>

    <section [style.display]="activeTab === 'display-conditions' ? null : 'none'">
      @if (displayConditionsGroup; as displayConditionsForm) {
        <smart-cart-form-display-conditions [formGroup]="displayConditionsForm"></smart-cart-form-display-conditions>
      }
    </section>
  </div>
</div>
